import { api } from '@restaurant/api';
import { PrinterType } from '@restaurant/types';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Button, Select } from 'antd';
import React, { useMemo, useState } from 'react';
import storage from '~/storage';
import message from '~/utils/message';

const KEY = 'selected_printer_id';

const Print = ({ id }: { id: string }) => {
  const { data: printers } = useSuspenseQuery({
    queryKey: ['fetchPrinters'],
    queryFn: async () => {
      const { printers } = await api.fetchPrinters();
      return printers ?? [];
    },
    gcTime: Infinity,
    staleTime: Infinity,
  });

  const activePrinters = useMemo(() => {
    return printers.filter(({ isActive }) => isActive);
  }, [printers]);

  const [selectedPrinterId, setSelectedPrinterId] = useState(() => {
    const prevSelectedId = storage.get(KEY, null);
    if (typeof prevSelectedId !== 'string' || !prevSelectedId) return null;

    if (activePrinters.every(({ printerId }) => printerId !== prevSelectedId)) {
      return null;
    }
    return prevSelectedId;
  });

  const saveSelectedPrinterId = (val: string) => {
    setSelectedPrinterId(val);
    storage.set(KEY, val);
  };

  const onClick = async () => {
    if (!selectedPrinterId) return;
    try {
      await api.printOrderReceipt({
        orderId: id,
        printMethod: PrinterType.Wifi,
        printerId: selectedPrinterId,
      });
      message.success('Berhasil printt');
    } catch (e: any) {
      message.error(e.message);
    }
  };

  return (
    <div className="px-4 mt-6">
      <p className="mb-2 text-lg">Print</p>
      <div className="flex items-center gap-2">
        <Select
          value={selectedPrinterId}
          placeholder="Pilih printer"
          options={activePrinters.map(({ printerId, name }) => ({
            label: name,
            value: printerId,
          }))}
          onChange={saveSelectedPrinterId}
          className="w-[200px]"
        />
        <Button type="primary" onClick={onClick} disabled={!selectedPrinterId}>
          Print
        </Button>
      </div>
    </div>
  );
};

export default Print;
